import classNames from "classnames";
import PropTypes from "prop-types";

import "./table-wrapper.scss";

const TableWrapper = ({ children, className = "", hasPagination = false }) => (
  <div
    data-testid="table-wrapper"
    className={classNames(
      "flex min-h-0 w-full flex-grow flex-col pb-6",
      className
    )}
  >
    <div
      className={classNames("min-h-0 flex-grow", {
        "neeto-molecules-tablewrapper-pagination--height": hasPagination,
      })}
    >
      {children}
    </div>
  </div>
);

TableWrapper.propTypes = {
  /**
   * Custom classnames for table wrapper.
   */
  className: PropTypes.string,
  /**
   * Handles table wrapper height when pagination is enabled.
   *
   * `hasPagination={totalCount > defaultPageSize}`
   */
  hasPagination: PropTypes.bool,
};

export default TableWrapper;
